import FormularioRD from "../rdstation/formularioRD";
import { useModal } from "../contexts/ModalContext";

export default function BannerVenturesEstrategia({
    headingBold,
    headingText,
    buttonText,
    buttonUrl = "#",
}) {
    const { openModal } = useModal();
    return (
        <div className="bg-[#040116] bg-[url(../assets/banner-ventures-estrategia-mobile.png)] md:bg-[url(../assets/banner-ventures-estrategia.png)] bg-no-repeat bg-cover bg-left text-white px-8 md:px-30 min-h-[500px] flex flex-col justify-end md:justify-center">
            <div className="container mx-auto py-4 md:py-24">
                <section className="max-w-[560px] w-full ms-auto space-y-8 font-inter-light flex flex-col items-center md:items-start">
                    <h2 className="text-2xl md:text-[40px] leading-[1.4] text-center md:text-left px-8 md:px-0">
                        <strong className="font-inter-medium">{headingBold}</strong>
                        {headingText}
                    </h2>
                    <button
                        onClick={() => openModal(<FormularioRD />)}
                        className="rounded-full bg-white text-[#422776] py-3 px-12 w-fit text-xl font-inter-bold hover:scale-105 transition-all duration-300 cursor-pointer inline-block mb-6 md:mb-0"
                    >
                        {buttonText}
                    </button>
                </section>
            </div>
        </div>
    );
}
